import React from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { Typography } from '@ui';
import { Col, Form, Row, Switch } from 'antd';
import { FIELD_NAMES } from '../../../../../constants';

const AddToCarts = () => {
    return (
        <Row align='middle' gutter={[48, 48]} wrap={false} style={BOTTOM_INDENTS.M} justify='space-between'>
            <Col>
                <Typography.Text data-e2e='tracking_add-to-carts_block' type='badgeSmall' style={BOTTOM_INDENTS.XXS}>
                    Add-To-Carts
                </Typography.Text>
                <Typography.Text
                    data-e2e='tracking_add-to=carts_description'
                    color={COLORS.$gray60Black}
                    type='descriptor2'
                >
                    Track add-to-carts in Google Analytics, including both in-widget and in-Klickly product add-to-carts
                </Typography.Text>
            </Col>
            <Col>
                <Form.Item name={FIELD_NAMES.GOOGLE_ANALYTICS_ADD_TO_CART} valuePropName='checked'>
                    <Switch data-e2e='tracking_add-to-carts_toggle' />
                </Form.Item>
            </Col>
        </Row>
    );
};

export default AddToCarts;
